import { createReducer } from 'service/utility';

import { SIDE_MENU_OPEN } from '../actions/appActions';


const initialState = true;

export default createReducer(initialState, {
  [SIDE_MENU_OPEN]: (state, { sideMenuOpen }) => sideMenuOpen,
});
